import React, { Component } from 'react';
import Head from 'next/head';

import { pages } from '../content.json';

class Testimonials extends Component {

  render(){

		const { testimonials } = pages;

		return(

			<div>

				<Head>
					<meta name="description" content={ testimonials.meta.description } />
					<title>{ testimonials.meta.title }</title>
				</Head>

				<div className="testimonials">

					<div className="testimonials-header">
						<div className="container-fluid">
							<div className="row">
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<h1>{ testimonials.title }</h1>
								</div>
							</div>
						</div>
					</div>

					<div className="testimonials-body">
						{
							testimonials.content.map( ( item, index ) =>
							<div key={ index } className={ index % 2 ? 'testimonials-item even' : 'testimonials-item odd' }>
								<div className="container-fluid">
									<div className="row">
										<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
											<div className="testimonials-item-body">
												{
													item.content.map( ( item, i ) =>
													<p key={ i }>"{ item }"</p>
													)
												}
											</div>
											<div className="testimonials-item-footer">
												<p><em>{ item.title }</em></p>
											</div>
										</div>
									</div>
								</div>
							</div>
							)
						}
					</div>

				</div>

			</div>

		);

	}

}

export default Testimonials;
